import { useMemo } from "react";

import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import type { ICountryObject } from "app/services/CountryService";
import { US_COUNTRY_ID } from "app/services/countryServiceConst";
import type { IRegionObject } from "app/services/RegionService";

type PlaybookLocationOptions = {
    countries: readonly ICountryObject[];
    regions: readonly IRegionObject[];
};

export const usePlaybookLocationOptions = (): PlaybookLocationOptions => {
    return useMemo(() => {
        const countries = settingsService
            .getCompanyInformationCountries()
            .filter((country) => country.parent !== US_COUNTRY_ID);
        const regions = settingsService.getRegions();

        return { countries, regions };
    }, []);
};
